import { childMixin as child } from './child'
import { rootMixin as root } from './root'
import { safeScopedSlotMixin as safeScopedSlot } from './safeScopedSlot'

export const childMixin = child
export const rootMixin = root
export const safeScopedSlotMixin = safeScopedSlot



// WEBPACK FOOTER //
// ./src/lib/v-calendar/utils/mixins/index.js